"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maxAttendeesPerEvent = exports.eventStatuses = exports.attendeeResponseStatus = exports.accessRoles = exports.WEEK_DAY = exports.VIEW_TYPES = exports.TIME_FORMAT = exports.REPEAT_OPTION_NAMES = exports.REPEAT_OPTIONS = exports.REMINDER_MAX_TIME_WEEK = exports.MAX_NUM_REMINDERS = exports.FULLDAY_HEIGHT = exports.EVENT_BUTTON_MAIN = exports.DRAG_EVENT_TIMEOUT = exports.DEFAULT_DATE_RANGE_ERROR = exports.DATE_TIME_FORMAT = exports.DATE_RANGE_DELIMITER = exports.DATE_FORMAT = exports.CALENDAR_BODY_ID = exports.ALERT_METHODS = void 0;
var WEEK_DAY = exports.WEEK_DAY = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday'
};
var VIEW_TYPES = exports.VIEW_TYPES = {
  week: 'week',
  month: 'month',
  day: 'day'
};
var DATE_TIME_FORMAT = exports.DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
var DATE_FORMAT = exports.DATE_FORMAT = 'YYYY-MM-DD';
var TIME_FORMAT = exports.TIME_FORMAT = 'h:mma';
var REPEAT_OPTIONS = exports.REPEAT_OPTIONS = [''];
var REPEAT_OPTION_NAMES = exports.REPEAT_OPTION_NAMES = {};
var ALERT_METHODS = exports.ALERT_METHODS = {
  notification: 'popup',
  email: 'email'
};
var REMINDER_MAX_TIME_WEEK = exports.REMINDER_MAX_TIME_WEEK = 4;
var MAX_NUM_REMINDERS = exports.MAX_NUM_REMINDERS = 5;
var FULLDAY_HEIGHT = exports.FULLDAY_HEIGHT = 2.5;
var DRAG_EVENT_TIMEOUT = exports.DRAG_EVENT_TIMEOUT = 300;
var EVENT_BUTTON_MAIN = exports.EVENT_BUTTON_MAIN = 0;
var CALENDAR_BODY_ID = exports.CALENDAR_BODY_ID = 'calendar-body';
var DATE_RANGE_DELIMITER = exports.DATE_RANGE_DELIMITER = '-';
var DEFAULT_DATE_RANGE_ERROR = exports.DEFAULT_DATE_RANGE_ERROR = 'Invalid date range';
var attendeeResponseStatus = exports.attendeeResponseStatus = {
  NEEDS_ACTION: 'NEEDS-ACTION',
  DECLINED: 'DECLINED',
  TENTATIVE: 'TENTATIVE',
  ACCEPTED: 'ACCEPTED'
};
var accessRoles = exports.accessRoles = {
  FREE_BUSY_READER: 'freeBusyReader',
  READER: 'reader',
  WRITER: 'writer',
  OWNER: 'owner'
};
var eventStatuses = exports.eventStatuses = {
  CONFIRMED: 'confirmed',
  TENTATIVE: 'tentative',
  CANCELLED: 'cancelled'
};
var maxAttendeesPerEvent = exports.maxAttendeesPerEvent = 100;
//# sourceMappingURL=constants.js.map